import { instance } from "./api";

export async function getPlantationList(payloads) {
  const { results, page, filters } = payloads;

  const applyFilter = filters?.length > 0 ? "&filter=" + filters : "";
  const response = await instance.get(
    `user/plantationData?limit=${results}&page=${page}${applyFilter}`
  );
  return response.data;
}

export async function getPlantationType() {
  const response = await instance.get("/user/category/Plantation Type");
  return response.data;
}

export async function createPlantationData(payload) {
  const formData = new FormData();
  formData.append("Plot_Auto_ID", payload.Plot_Auto_ID);
  formData.append("Plant_Auto_ID", payload.Plant_Auto_ID);
  formData.append("Plant_Type", payload.Plant_Type);
  formData.append("Total_Plant_Count", payload.Total_Plant_Count);
  formData.append(
    "Total_Plant_Monitoring_Count",
    payload.Total_Plant_Monitoring_Count
  );
  formData.append("Latitude", payload?.Latitude);
  formData.append("Longitude", payload.Longitude);
  formData.append("Location", payload.Location);
  formData.append("Altitude_meter", payload.Altitude_meter);

  // new changes - tag v3.0.1
  formData.append("Aspect", payload.Aspect);
  formData.append("Soil_Texture", payload.Soil_Texture);
  const response = await instance.post("user/plantation", formData);
  return response.data;
}

/* new changes - tag v3.0.1 */

export async function updatePlantationData(payload) {
  const formData = new FormData();
  formData.append("Plant_Type", payload.Plant_Type);
  formData.append("Latitude", payload.Latitude);
  formData.append("Longitude", payload.Longitude);
  formData.append("Location", payload.Location);
  formData.append("Altitude_meter", payload.Altitude_meter);
  // new changes - tag v3.0.1
  formData.append("Aspect", payload.Aspect);
  formData.append("Soil_Texture", payload.Soil_Texture);
  const response = await instance.post(
    `user/plantation/${payload.params}`,
    formData
  );
  return response.data;
}

/* new changes - tag v3.0.3 */
export async function getPlants(payload) {
  const { filter } = payload ?? {};
  let applyFilter = filter ? `?filter=${filter}` : "";
  const response = await instance.get(`admin/getPlants${applyFilter}`);
  return response.data;
}
